export const CUSTOM_DATE_FORMATS = {
    parse: {
      dateInput: 'DD. MMM YYYY',
    },
    display: {
      dateInput: 'DD. MMM YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
};
